import { createStore } from 'vuex';

export const trendsStore = createStore({
  state: {
    selectedRegion: 'US',
    selectedCategory: '',
    regions: [],
    categories: [],
    trendsData: null,
    recommendations: null,
    loading: false,
    error: null,
    // Add caching capabilities
    lastFetched: null,
    cacheTime: 5 * 60 * 1000 // 5 minutes
  },
  mutations: {
    setSelectedRegion(state, region) {
      state.selectedRegion = region;
    },
    setSelectedCategory(state, category) {
      state.selectedCategory = category;
    },
    setRegions(state, regions) {
      state.regions = regions;
    },
    setCategories(state, categories) {
      state.categories = categories;
    },
    setTrendsData(state, data) {
      state.trendsData = data;
    },
    setRecommendations(state, recommendations) {
      state.recommendations = recommendations;
    },
    setLoading(state, loading) {
      state.loading = loading;
    },
    setError(state, error) {
      state.error = error;
    },
    setLastFetched(state, timestamp) {
      state.lastFetched = timestamp;
    },
    clearCache(state) {
      state.trendsData = null;
      state.recommendations = null;
      state.lastFetched = null;
    }
  },
  actions: {
    updateSelectedRegion({ commit }, region) {
      commit('setSelectedRegion', region);
    },
    updateSelectedCategory({ commit }, category) {
      commit('setSelectedCategory', category);
    },
    initializeRegions({ commit }, regions) {
      commit('setRegions', regions);
    },
    initializeCategories({ commit }, categories) {
      commit('setCategories', categories);
    },
    updateTrendsData({ commit }, data) {
      commit('setTrendsData', data);
      commit('setLastFetched', Date.now());
    },
    clearTrendsCache({ commit }) {
      commit('clearCache');
    }
  },
  getters: {
    currentRegion: (state) => state.selectedRegion,
    currentCategory: (state) => state.selectedCategory,
    availableRegions: (state) => state.regions,
    availableCategories: (state) => state.categories,
    getCurrentRegionName: (state) => {
      const region = state.regions.find(r => r.code === state.selectedRegion);
      return region ? region.name : state.selectedRegion;
    },
    getCurrentCategoryName: (state) => {
      if (!state.selectedCategory) return 'All Categories';
      const category = state.categories.find(c => c.id === state.selectedCategory);
      return category ? category.name : 'All Categories';
    },
    isCacheValid: (state) => {
      if (!state.lastFetched) return false;
      return (Date.now() - state.lastFetched) < state.cacheTime;
    },
    hasCachedData: (state) => state.trendsData !== null
  }
});
